import React, { useEffect, useState } from 'react';
import RecordingFee from 'src/models/RecordingFee';
import Card from 'src/components/common/Card.redesign';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import useFetch from 'use-http';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import State from 'src/models/State';
import County from 'src/models/County';
import { SelectItem } from 'src/models/common/SelectItem';
import { FormRow } from 'src/components/controls/forms/reactHookForm';
interface IRecordingFeeCard {
    recordingFee: RecordingFee;
    index: number;
    clientNumber: number;
    projectNumber: number;
    invoiceId: number;
    invoiceNumber: string;
    states: State[];
    counties: County[];
    indexTypes: SelectItem[];
    dispositions: SelectItem[];
    submitListener: boolean;
    updateRecordFees: (v: number) => void;
    onCloseDialog: () => void;
}
const RecordingFeeCard = (props: IRecordingFeeCard) => {
    const defaultValues: RecordingFee = {
        id: 0,
        stateId: 0,
        countyId: 0,
        dispositionId: 0,
        indexTypeId: 0,
        invoiceId: props.invoiceId,
        documentNumber: '',
        page: '',
        recordDate: null,
        recordingFeeAmount: 0,
        assignNumber: '',
        assignDate: null,
        transmitNumber: '',
        transmitDate: null,
        lessorName: null,
        documentType: null,
        reqNumber: null,
        legalDescription: null,
        pages: 0
    };
    const [recordingFeeData, setRecordingFeeData] = useState<RecordingFee>(defaultValues);
    const [dispositionStatus, setDispositionStatus] = useState<string>('');
    const [assignmentOrTransmittal, setAssignmentOrTransmittal] = useState(undefined);
    const [stateCounties, setStateCounties] = useState<County[]>([]);
    const { put, post } = useFetch();
    const { register, getValues, setValue, handleSubmit, reset, errors } = useForm();

    useEffect(() => {
        getStateCounties(true);
        updateFormFields();
    }, [props.recordingFee, props.counties]);

    useEffect(() => {
        if (props.recordingFee !== undefined && props.recordingFee !== null) {
            setRecordingFeeData(formatData(props.recordingFee));
        }
    }, [props.recordingFee]);

    useEffect(() => {
        reset(recordingFeeData);
    }, [recordingFeeData]);

    useEffect(() => {
        setAssignmentOrTransmittal(updateAssignmentOrTransmittal());
    }, [dispositionStatus]);

    useEffect(() => {
        if (recordingFeeData?.countyId && recordingFeeData.countyId > 0) {
            setValue('countyId', 0);
            setValue('countyId', recordingFeeData.countyId);
        }
    }, [stateCounties]);

    useEffect(() => {
        if (props.submitListener) {

            let ref = getValues();
            let recordingFee: RecordingFee = {
                id: props.recordingFee?.id ? props.recordingFee.id : 0,
                stateId: ref.stateId ? ref.stateId : 0,
                countyId: ref.countyId ? ref.countyId : 0,
                dispositionId: ref.dispositionId ? ref.dispositionId : 0,
                indexTypeId: ref.indexTypeId ? ref.indexTypeId : 0,
                invoiceId: props.invoiceId ? parseInt(props.invoiceId + '', 10) : null,
                pages: ref.pages ? ref.pages : 0,
                recordingFeeAmount: ref.recordingFeeAmount ? ref.recordingFeeAmount : 0,

                documentNumber: ref.documentNumber ? ref.documentNumber : '',
                page: ref.page ? ref.page : '',
                assignNumber: ref.assignNumber ? ref.assignNumber : '',
                transmitNumber: ref.transmitNumber ? ref.transmitNumber : '',
                lessorName: ref.lessorName ? ref.lessorName : '',
                reqNumber: ref.reqNumber ? ref.reqNumber : '',
                documentType: ref.documentType ? ref.documentType : '',
                legalDescription: ref.legalDescription ? ref.legalDescription : '',
                recordDate: ref.recordDate ? (moment(ref.recordDate).format('YYYY-MM-DD') as unknown as Date)
                                : (moment().format('YYYY-MM-DD') as unknown as Date),
                assignDate: ref.assignDate ? (moment(ref.assignDate).format('YYYY-MM-DD') as unknown as Date)
                                : (moment().format('YYYY-MM-DD') as unknown as Date),
                transmitDate: ref.transmitDate ? (moment(ref.transmitDate).format('YYYY-MM-DD') as unknown as Date)
                                : (moment().format('YYYY-MM-DD') as unknown as Date)
            };

            onSubmit(recordingFee); 
        }
    }, [props.submitListener]);
    const onSubmit = async (recordingFee: RecordingFee) => {
        recordingFee = formatData(recordingFee);
        if (recordingFee.id === 0) {
            await post(`v1.0/clients/${props.clientNumber}/projects/${props.projectNumber}/recordingFee`, recordingFee);
        } else {
            await put(`v1.0/clients/${props.clientNumber}/projects/${props.projectNumber}/recordingFee`, recordingFee);
        }
        props.onCloseDialog();
    };
    const formatData = (data: RecordingFee) => {
        data.id = props.recordingFee?.id ? parseInt(props.recordingFee.id + '', 10) : 0;
        data.stateId = data.stateId ? parseInt(data.stateId + '', 10) : null;
        data.countyId = data.countyId ? parseInt(data.countyId + '', 10) : null;
        data.dispositionId = data.dispositionId ? parseInt(data.dispositionId + '', 10) : null;
        data.indexTypeId = data.indexTypeId ? parseInt(data.indexTypeId + '', 10) : null;
        data.invoiceId = props.invoiceId ? parseInt(props.invoiceId + '', 10) : null;
        data.recordingFeeAmount = data.recordingFeeAmount ? parseFloat(data.recordingFeeAmount + '') : 0;
        data.pages = data.pages ? parseInt(data.pages + '', 10) : 0;
        data.documentNumber = data.documentNumber ? data.documentNumber : '';
        data.page = data.page ? data.page : '';
        data.assignNumber = data.assignNumber ? data.assignNumber : '';
        data.transmitNumber = data.transmitNumber ? data.transmitNumber : '';
        data.lessorName = data.lessorName ? data.lessorName : '';
        data.reqNumber = data.reqNumber ? data.reqNumber : '';
        data.documentType = data.documentType ? data.documentType : '';
        data.legalDescription = data.legalDescription ? data.legalDescription : '';
        data.recordDate = data.recordDate
            ? (moment(data.recordDate).format('YYYY-MM-DD') as unknown as Date)
            : (moment().format('YYYY-MM-DD') as unknown as Date);
        data.assignDate = data.assignDate
            ? (moment(data.assignDate).format('YYYY-MM-DD') as unknown as Date)
            : (moment().format('YYYY-MM-DD') as unknown as Date);
        data.transmitDate = data.transmitDate
            ? (moment(data.transmitDate).format('YYYY-MM-DD') as unknown as Date)
            : (moment().format('YYYY-MM-DD') as unknown as Date);

        return data;
    };
    const updateTotals = () => {
        let rep = getValues();
        props.updateRecordFees(rep.recordingFeeAmount);
    };

    const updateFormFields = () => {
        let rep = getValues();

        if (parseInt(rep.dispositionId, 10) === props.dispositions?.find(d => d.name === 'TBA')?.id) {
            setDispositionStatus('Assign');
        } else if (parseInt(rep.dispositionId, 10) === props.dispositions?.find(d => d.name === 'TBT')?.id) {
            setDispositionStatus('Transmit');
        } else {
            setDispositionStatus('');
        }
    };

    const updateAssignmentOrTransmittal = () => {
        if (dispositionStatus === 'Assign') {
            return (
                <>
                    <RHFInputBox name="assignNumber" label="Assign Number" register={register} errors={errors} bodyStyle={{ width: '15%' }}/>
                    <RHFInputBox name="assignDate" label="Assigned Date" register={register} errors={errors} type="date" bodyStyle={{ width: '15%' }}/>
                </>
            );    
        } else if (dispositionStatus === 'Transmit') {
            return (
                <>
                    <RHFInputBox name="transmitNumber" label="Transmit Number" register={register} errors={errors} bodyStyle={{ width: '15%' }}/>
                    <RHFInputBox name="transmitDate" label="Transmitted Date" register={register} errors={errors} type="date" bodyStyle={{ width: '15%' }}/>
                </>
            );
        } else {
            return <div />;
        }

    };

    const getStateCounties = (isInit: boolean) => {
        let stateId = isInit ? props.recordingFee.stateId : parseInt(getValues().stateId, 10);

        let currentCounties: County[] = [];
        props.counties.forEach(c => {
            if (c.stateId === stateId) {
                currentCounties.push(c);
            }
        });
        setStateCounties(currentCounties);
    };

    return(
        <Card key={props.index} className="small-input" newContext={true}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <FormRow style={{ display: 'flex', gap: '1rem' }}>
                    <RHFSelect
                        name="stateId"
                        label="State"
                        options={props.states.map(s => {
                           return { value: s.id, label: s.name };
                        })}
                        onChange={() => getStateCounties(false)}
                        register={register}
                        bodyStyle={{ width: '15%' }}
                    />
                    <RHFSelect
                        name="countyId"
                        label="County"
                        options={stateCounties.map(c => {
                           return { value: c.id, label: c.name };
                        })}
                        register={register}
                        bodyStyle={{ width: '15%' }}
                    />
                    <RHFSelect
                        name="dispositionId"
                        label="Disposition"
                        options={props.dispositions.map(d => {
                           return { value: d.id, label: d.name };
                        })}
                        onChange={() => updateFormFields()}
                        register={register}
                        bodyStyle={{ width: '15%' }}
                    />
                    <RHFSelect
                        name="indexTypeId"
                        label="Instrument Type"
                        options={props.indexTypes.map(i => {
                           return { value: i.id, label: i.name };
                        })}
                        register={register}
                        bodyStyle={{ width: '15%' }}
                    />
                    {assignmentOrTransmittal}
                </FormRow>
                <FormRow style={{ display: 'flex', gap: '1rem' }}>
                    {/* tslint:disable-next-line */}
                    <RHFInputBox name="documentNumber" label="Book/Doc Number" register={register} errors={errors} bodyStyle={{ width: '15%' }}/>
                    <RHFInputBox name="documentType" label="Doc. Type" register={register} errors={errors} bodyStyle={{ width: '15%' }}/>
                    {/* tslint:disable-next-line */}
                    <RHFInputBox name="page" label="Page Number" register={register} errors={errors} bodyStyle={{ width: '15%' }}/>
                    <RHFInputBox name="lessorName" label="Lessor/Name on Document" register={register} errors={errors} bodyStyle={{ width: '15%' }}/>
                    <RHFInputBox name="reqNumber" label="Req Number" register={register} errors={errors} bodyStyle={{ width: '15%' }}/>
                    <RHFInputBox name="pages" label="Pages" register={register} errors={errors} type="number" bodyStyle={{ width: '15%' }}/>
                </FormRow>
                <FormRow style={{ display: 'flex', gap: '1rem' }}>
                    <RHFInputBox name="legalDescription" label="Legal" register={register} errors={errors} style={{ width: '100%' }} />
                </FormRow>
                <FormRow>
                    {/* tslint:disable-next-line */}
                    <RHFInputBox name="recordingFeeAmount" label="Recording Fee" onChange={() => updateTotals()} disabled={props.recordingFee?.id && props.recordingFee.id > 0} register={register} errors={errors} type="number" />
                </FormRow>
            </form>
        </Card>
    );
};
export default RecordingFeeCard;


// WEBPACK FOOTER //
// ./src/components/invoicing/components/RecordingFeeCard.tsx